import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './StreakPage.css';
import { s3PublicUrl } from '../../utils/s3PublicUrl';

export default function StreakPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const themeData = useSelector((state) => state.theme?.data);

  const state = location.state || {};
  const dayNumber = useMemo(() => {
    const n = Number(state.dayNumber);
    return Number.isFinite(n) ? n : null;
  }, [state.dayNumber]);
  const stageId = useMemo(() => {
    const n = Number(state.stageId);
    return Number.isFinite(n) ? n : null;
  }, [state.stageId]);
  const bonusToasts = useMemo(
    () => (Array.isArray(state.bonusToasts) ? state.bonusToasts : []),
    [state.bonusToasts]
  );
  const [showBonusToasts, setShowBonusToasts] = useState(true);

  useEffect(() => {
    if (!bonusToasts.length) return;
    const t = window.setTimeout(() => setShowBonusToasts(false), 3000);
    return () => window.clearTimeout(t);
  }, [bonusToasts.length]);

  const stageKey = dayNumber ? `stage_${dayNumber}` : null;
  const stage = stageKey ? themeData?.stages_data?.[stageKey] : null;

  const streakMessage = String(stage?.streak_message ?? '').trim();
  const streakImg = s3PublicUrl(stage?.streak);
  const bonusImg = s3PublicUrl(stage?.bonus_streak_badge);

  const showBonus = dayNumber === 3 || dayNumber === 5 || dayNumber === 7;
  const streakImgs = useMemo(() => {
    const out = [];
    if (streakImg) out.push({ key: 'streak', src: streakImg, alt: 'Streak badge' });
    if (showBonus && bonusImg) out.push({ key: 'bonus', src: bonusImg, alt: 'Bonus streak badge' });
    return out;
  }, [streakImg, bonusImg, showBonus]);

  if (!dayNumber) {
    // No state passed → go home
    navigate('/main', { replace: true });
    return null;
  }

  return (
    <div className="streak-page">
      <div className="streak-card">
        {bonusToasts.length > 0 && showBonusToasts ? (
          <div className="streak-bonus-layer" aria-hidden>
            {bonusToasts.map((b, idx) => (
              <div key={`${b.label || 'bonus'}-${idx}`} className="streak-bonus-toast">
                +{Number(b.points) || 0}
              </div>
            ))}
          </div>
        ) : null}
        <h1 className="streak-title">Day {dayNumber}</h1>

        {streakMessage ? <p className="streak-message">{streakMessage}</p> : null}

        <div
          className={`streak-badges ${streakImgs.length > 1 ? 'streak-badges--two' : ''}`}
          role="img"
          aria-label="Streak badges"
        >
          {streakImgs.map((b) => (
            <img key={b.key} src={b.src} alt={b.alt} className="streak-badge-img" />
          ))}
        </div>

        <div className="streak-actions">
          <button
            type="button"
            className="streak-next-btn"
            onClick={() => navigate('/feedback', { replace: true, state: { dayNumber, stageId } })}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}

